import React from 'react';
import { Link, useNavigate } from 'react-router-dom'; 
import ResllerLogo from '../images/Reseller Logo.svg';

import './ResellerNavbar.scss';
const ResellerNavbar = () => {
    const navigate=useNavigate();
    const handleClick = () => {
      // Get a reference to the element you want to scroll to
      const element = document.getElementById('elementId');
  
      if (element) {
        // Scroll to the element
        element.scrollIntoView({ behavior: 'smooth' });
      }
    };
    const seller=  localStorage.getItem("sellerregisterInfo");
    const sellerInfoObject = JSON.parse(seller);
  return (
    <nav className="Resellernavbar" style={{display:"flex"}} >
<div className='Boxshadow' style={{display:"flex"}}>
      <ul className="nav-list" style={{display:"flex"}}>
        <li><img src={ResllerLogo} alt="Company Logo" className="company-logo" /></li>
        <div className="Homeresellerhead" style={{display:"flex"}}>
          
        <div className='Homereseller' style={{display:"flex"}}>
        <li>Home</li>
        <li onClick={handleClick}>FAQ</li>
        <li  onClick={()=>{navigate("/contactus")}}>Contact Us</li>
        </div>
    <div style={{display:"flex"}}>
{sellerInfoObject?
(

<>
<button className="sell-button" onClick={() => { navigate("/dashboard"); } }>Log in</button></>
  ):(
  <><li><button className="login-button" onClick={() => { navigate("/login"); } }>Log in</button></li><li>    <button className="sell-button" onClick={() => { navigate("/login"); } }>Start Selling</button></li></>
)}
    </div>
    </div>
      </ul>
      </div> 
    </nav>
  );
};

export default ResellerNavbar;
